import { Divider, Typography } from "antd";
import { AuthMode } from "auth/types";
import { AuthContent } from "components/Layout/components/Content";
import { Header } from "components/Layout/components/Header";
import { MasterLayout } from "components/Layout/components/MasterLayout";
import { getAuthMode } from "config/config";

import { BasicLoginPage } from "./BasicLoginPage";
import { MsEntraLoginPage } from "./MsEntraLoginPage";
import { NoneLoginPage } from "./NoneLoginPage";
import { AuthFormWrapper } from "./Styles";

const { Title } = Typography;

export const AuthPage = () => {
    const authMode = getAuthMode();

    return (
        <MasterLayout>
            <Header />
            <AuthContent>
                <AuthFormWrapper id="pageContent">
                    <Title level={3} style={{ textAlign: "center" }}>
                        Welcome Back
                    </Title>
                    <Divider />

                    {authMode === AuthMode.MS_ENTRA && <MsEntraLoginPage />}
                    {authMode === AuthMode.BASIC && <BasicLoginPage />}
                    {authMode === AuthMode.NONE && <NoneLoginPage />}
                </AuthFormWrapper>
            </AuthContent>
        </MasterLayout>
    );
};
